<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="acknow">
<p class="ct"><a class="xref" href="#/pppscavenger005#toc">Acknowledgments</a></p>
<p class="pf">Special thanks to Ralph Altizer, Virgil Hall, David Martinez, H. L. McArthur, and Larry Youngblood.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pppscavenger006.vue?5cc7fff8